import { render, staticRenderFns } from "./captain_bonus_types.vue?vue&type=template&id=5ff2c776&scoped=true&"
import script from "./captain_bonus_types.vue?vue&type=script&lang=js&"
export * from "./captain_bonus_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff2c776",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ff2c776')) {
      api.createRecord('5ff2c776', component.options)
    } else {
      api.reload('5ff2c776', component.options)
    }
    module.hot.accept("./captain_bonus_types.vue?vue&type=template&id=5ff2c776&scoped=true&", function () {
      api.rerender('5ff2c776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/captain_bonus_types.vue"
export default component.exports